import keyBy from 'lodash/keyBy';
import uniqueId from 'lodash/uniqueId';

import { TArticle } from '~/src/features/internetV2/store/reducer';

interface IBaseArticleData {
    question: string,
    answer: string,
    id?: number,
}

export const articlesToKeyDataMap = (articles: Array<IBaseArticleData | TArticle>): Record<string, TArticle> =>
    keyBy(
        (articles).map(({ question, answer, id = uniqueId() }) => (
            {
                question,
                answer,
                key: id.toString(),
                id: +id,
                isOpen: false,
            })),
        'id',
    );
